import { Title } from '../components/title';
import { X } from 'lucide-react';
import { useLocation } from 'wouter';
import { useUser } from '../query';
import { Spinner } from '../components/spinner';
import { PersonalProfile } from '../components/personal-profile';
import { PersonalGallery } from '../components/personal-gallery';
import styles from './personal-page.module.css';

export const PersonalPage = ({ username }: { username: string }) => {
  const [_location, navigate] = useLocation();
  const {
    isError,
    isLoading,
    data: user,
  } = useUser(username);

  return (
    <>
      <Title title={ username } />
      <dialog
        id="personal-page"
        className={ styles.dialog }
        onClose={ () => navigate('/') }
        open
      >
        <button
          type="button"
          className={ styles.closeOverlay }
          // @ts-ignore - command is a valid property for buttons
          command="close"
          // @ts-ignore - commandFor is a valid property for buttons
          commandFor="personal-page"
        >
          <span className="visually-hidden">Close</span>
        </button>
        <button
          type="button"
          className={ styles.closeButton }
          // @ts-ignore - command is a valid property for buttons
          command="close"
          // @ts-ignore - commandFor is a valid property for buttons
          commandFor="personal-page"
        >
          <span className="visually-hidden">Close</span>
          <X />
        </button>
        <main data-state={ isError ? 'error' : isLoading ? 'loading' : 'ready' }>
          { !isError && isLoading && <Spinner /> }
          { !isError && user && <PersonalProfile user={ user } /> }
          { !isError && user && <PersonalGallery user={ user } /> }
          { isError && <p className={ styles.error }>Error loading user</p> }
        </main>
      </dialog>
    </>
  );
};